import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/activePackagesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const ActivePackagesView = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.activePackages.moduleView);
  const selectedView = useSelector((state) => state.activePackages.selectedFilters.moduleView);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedView}
      placeholder="Select View"
      numberDisplayed={0}
      multiple={false}
      keepOpen={false}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedView.id) return;
        dispatch(actionCreators.updateModuleView(data));
      }}
    />
  );
};

export default ActivePackagesView;
